export default {
    commonObj: state => state.commonObj
  }
